export default __webpack_public_path__ + "static/app-features-2--mobile-2dec9e8cff3224ee8b9a2cea529bd91c.png";